import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var AccountNameTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(AccountNameTransformer, _BaseTransformer);
  var _super = _createSuper(AccountNameTransformer);
  function AccountNameTransformer() {
    _classCallCheck(this, AccountNameTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(AccountNameTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        value: data.record_id,
        label: data.account_name,
        account_name: data.account_name,
        record_id: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return AccountNameTransformer;
}(BaseTransformer);